import React from "react";
import { Crown, Mail, Phone, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#0A0A0A] border-t border-white/10 mt-24">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2">
            <Crown className="w-5 h-5 text-[#C5A059]" />
            <span className="font-heading text-xl tracking-tight text-white">
              BLACK<span className="text-[#C5A059]">·</span>SAPPHIRE
            </span>
          </div>
          <div className="text-[10px] tracking-[0.4em] uppercase text-[#C5A059]/80 mt-2 ml-7">
            The Quiet Standard
          </div>
          <p className="text-[#A3A3A3] text-sm leading-relaxed mt-5 max-w-md">
            Discreet, on-time and uncompromising. Black Sapphire is a private black-car service
            for executives, dignitaries and special occasions across 40+ cities.
          </p>
          <div className="mt-6 text-xs uppercase tracking-[0.25em] text-[#C5A059]">
            Available 24 / 7 / 365
          </div>
        </div>

        <div>
          <h4 className="font-heading text-white text-base mb-4">Services</h4>
          <ul className="space-y-2.5 text-sm text-[#A3A3A3]">
            <li>Airport Transfers</li>
            <li>Hourly Chauffeur</li>
            <li>Corporate Travel</li>
            <li>Special Events</li>
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-white text-base mb-4">Contact</h4>
          <ul className="space-y-3 text-sm text-[#A3A3A3]">
            <li className="flex items-center gap-2"><Phone className="w-3.5 h-3.5 text-[#C5A059]" /> +1 (800) BLK-SAPH</li>
            <li className="flex items-center gap-2"><Mail className="w-3.5 h-3.5 text-[#C5A059]" /> concierge@blacksapphire.com</li>
            <li className="flex items-center gap-2"><MapPin className="w-3.5 h-3.5 text-[#C5A059]" /> NYC · LA · MIA · CHI</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs uppercase tracking-[0.2em] text-white/40">© {new Date().getFullYear()} Black Sapphire · All Rights Reserved</p>
          <p className="text-xs uppercase tracking-[0.2em] text-white/40">Privacy · Terms · Code of Conduct</p>
        </div>
      </div>
    </footer>
  );
}
